module.exports = __webpack_public_path__ + "img/banner-1.fe344887.jpg";